import type { RoadKit } from "../kit/types";

/**
 * Moonlit Slate road (1,500 Marks; contract tools/art/skins/README.md §Roads). Irregular blue slate flagstones with dark
 * joints (the ground shader's paving, render/groundPave.ts) between dark slate kerbs with silver studs, dressed from
 * `art/hq/skins/slate/kit.glb` (tools/art/skins/roads.py): a slate roundel with a glowing blue moon rune every third
 * cell (the glow travels down the road), silver lamp posts whose pale lanterns flicker with will-o'-wisps circling them,
 * standing rune stones breathing light, and moonlit glints twinkling over the verge.
 */
export const SLATE: RoadKit = {
  id: "road.slate",
  tint: [0.66, 0.76, 0.98],
  asset: "skins/slate/kit",
  surface: {
    pattern: "flags", scale: 2.1, jointWidth: 0.07, grain: 0.7, bevel: 0.6,
    stone: [0.1, 0.13, 0.2], stone2: [0.17, 0.2, 0.28], joint: [0.03, 0.035, 0.05],
  },
  // the kerbs first: the instance cap (KIT_BUDGET.RoadInstances) fills piece by piece, so on a very long road it is the
  // verge dressing that thins out at the far end, never the edges
  pieces: [
    { piece: "kerb", every: 1, place: "centre", on: "straight" },
    { piece: "kerbturn", every: 1, place: "centre", on: "turn" },
    { piece: "rune", every: 3, place: "centre", on: "straight", motion: { glow: 0.6, hz: 0.3, travel: 0.7 } },
    { piece: "lamp", every: 4, phase: 1, place: "verge", side: 0.58, on: "straight", motion: { glow: 0.45, hz: 2.3 } },
    { piece: "wisps", every: 4, phase: 1, place: "verge", side: 0.58, on: "straight", lift: 0.59, motion: { spin: 1.3, bob: 0.03, hz: 0.6, glow: 0.5 } },
    { piece: "stone", every: 4, phase: 3, place: "verge", side: 0.58, on: "straight", motion: { glow: 0.5, hz: 0.35 } },
    { piece: "glint", every: 4, phase: 2, place: "verge", side: 0.48, detail: true, motion: { twinkle: 0.25 } },
  ],
};
